import { useI18n } from "@wojo/localization";
import { LoadingSkeleton } from "@wojo/ui";
import React from "react";
import styles from "./LoadingQuote.module.scss";

export const TripBuilderLoadingQuote: React.FC = () => {
    const { productPage } = useI18n("productPage");
    return (
        <>
            <div
                style={{
                    padding: "var(--g-spacing-md)",
                    borderBottom:
                        "var(--s-border-width-background-standard) solid var(--s-color-separator-standard)",
                }}
            >
                {/* Date */}
                <LoadingSkeleton
                    accessibleText={productPage.tripBuilder.quote.loadingAccessibleText.l()}
                    width="175"
                    height="24"
                />
            </div>
            <div
                style={{
                    paddingTop: "var(--g-spacing-lg)",
                    paddingLeft: "var(--g-spacing-md)",
                    paddingRight: "var(--g-spacing-md)",
                }}
            >
                {/* Travelers */}
                <LoadingSkeleton accessibleText="" width="100%" height="40px" />
                {/* Flight Picker */}
                <LoadingSkeleton
                    accessibleText=""
                    width="100%"
                    height="24px"
                    style={{ marginTop: "var(--g-spacing-lg)" }}
                />
                {[...Array(2)].map((_, index) => (
                    <div
                        className={styles["fallback-flight-option"]}
                        key={index}
                        style={{ marginTop: "var(--g-spacing-lg)" }}
                    >
                        <LoadingSkeleton
                            accessibleText=""
                            width="24px"
                            height="24px"
                            className={styles["fallback-flight-option-icon"]}
                        />
                        <LoadingSkeleton
                            accessibleText=""
                            width="50%"
                            height="24px"
                            className={styles["fallback-flight-option-line1"]}
                        />
                        <LoadingSkeleton
                            accessibleText=""
                            width="100%"
                            height="24px"
                            className={styles["fallback-flight-option-line2"]}
                        />
                    </div>
                ))}
                {/* Totals */}
                <LoadingSkeleton
                    accessibleText=""
                    width="100%"
                    height="24px"
                    style={{ marginTop: "var(--g-spacing-xl)" }}
                />
                <LoadingSkeleton
                    accessibleText=""
                    width="100%"
                    height="24px"
                    style={{ marginTop: "var(--g-spacing-md)" }}
                />
            </div>

            {/* Amount due */}
            <LoadingSkeleton
                accessibleText=""
                width="100%"
                height="58px"
                style={{
                    borderRadius: "0",
                    marginTop: "var(--g-spacing-xxl)",
                }}
            />

            {/* Submit */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <LoadingSkeleton
                    accessibleText=""
                    width="100px"
                    height="32px"
                    style={{ marginTop: "var(--g-spacing-lg)" }}
                />
            </div>
            {/* Notes */}
            <div style={{ padding: "var(--g-spacing-md)" }}>
                <LoadingSkeleton
                    accessibleText=""
                    width="100%"
                    height="40px"
                    style={{ marginTop: "var(--g-spacing-xxl)" }}
                />
                <LoadingSkeleton
                    accessibleText=""
                    width="100%"
                    height="24px"
                    style={{ marginTop: "var(--g-spacing-sm)" }}
                />
            </div>
        </>
    );
};
